import { TabPanel, Tabs } from "@commonlibs";
import { useControlled } from "@commonlibs";
import clsx from "clsx";
import { StatefulTabsContextI, StatefulTabsProvider } from "./context/TabsModalContext";
import { StatefulTabsProps } from "./StatefulTabs.types";

function StatefulTabs<T>({
    className,
    children,
    defaultState,
    initialIndex = 0,
    onIndexChange,
    index,
    state: stateProp,
    onStateChange,
    tabs,
    ...rest
}: StatefulTabsProps<T>) {
    const [state, setState] = useControlled<T>(defaultState as T, stateProp, onStateChange);
    const [activeTab, setActiveTab] = useControlled(initialIndex, index, onIndexChange);

    return (
        <Tabs className={clsx("stateful-tabs", className)} index={activeTab} onIndexChange={setActiveTab} {...rest}>
            <StatefulTabsProvider value={{ state, setActiveTab, setState, activeTab } as unknown as StatefulTabsContextI<unknown>}>
                <>
                    {children}
                    {tabs?.map(({ content }, index) => {
                        return (
                            <TabPanel key={index} index={index}>
                                {content}
                            </TabPanel>
                        );
                    })}
                </>
            </StatefulTabsProvider>
        </Tabs>
    );
}

export default StatefulTabs;
